import React from 'react';
import './UserPage.css';

import logoImage from './../../image/logo.svg';
import loadingIcon from './../../image/loading-icon.svg';
import QrIcon from './../../image/qr-icon.png';

const UserPage = ({ setCurrentPage, firstUserName, lastUserName }) => {
    const handleHistoryClick = () => {
        setCurrentPage('HistoryPage');
    };

    return (
        <div className='user__wrapper'>
            <div className='user__main_info'>
                <div className='user__logo'>
                    <img src={logoImage} alt='Logo' />
                </div>
                <div className='user__items'>
                    <div className='user__item_icon'>
                        <img src={loadingIcon} />
                    </div>
                    <div className='user__item_about'>
                        <div className='user__item_about_one'>
                            {`${firstUserName} ${lastUserName}`}
                        </div>
                        {/* <div className='user__item_about_two'>Уровень 1</div> */}
                    </div>
                    {/* <div className='user__item_count'>
                        Бонусы: <span>156</span>
                    </div> */}
                </div>
                {/* <div className='user__progress_items'>
                    <div className='user__progress_level'>
                        <p>Уровень 1</p>
                        <p>Уровень 2</p>
                    </div>
                    <div className='user__progress_task'>
                        <div className='user__progress_bar'></div>
                        <p>250/1000</p>
                    </div>
                </div> */}
                {/* <div className='user__progress_info'>
                    <p className='user__progress_info_one'>
                        Общая сумма заказов: <span>10000</span>
                    </p>
                    <p
                        className='user__progress_info_two'
                        onClick={handleHistoryClick}
                    >
                        История заказов
                    </p>
                </div> */}
                <div className='user__history_btns'>
                    <button
                        className='user__history_btn'
                        onClick={handleHistoryClick}
                    >
                        История заказов
                    </button>
                </div>
            </div>

            {/* <div className='user__qr_code_items'>
                <img src={QrIcon} />
                <p>
                    Покажите этот код персоналу, чтобы пользоваться функцией
                    вызова к столу
                </p>
            </div> */}
            {/* <div className='user__qr_code_info'>
                <p>Ваша карта лояльности привязана к другому номеру?</p>
                <a href='#'>Сменить номер телефона</a>
            </div> */}
        </div>
    );
};

export default UserPage;
